class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.querySelector('summary');
    this.mql = window.matchMedia('(min-width: 990px)');

    if (this.mql.matches) {
      this.setupHoverEvents();
    }

    this.mql.addEventListener('change', (e) => {
      if (e.matches) {
        this.setupHoverEvents();
      } else {
        this.removeHoverEvents();
      }
    });
  }

  setupHoverEvents() {
    this.summary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.summary.addEventListener('mouseleave', this.onSummaryMouseLeave.bind(this));
    this.content.addEventListener('mouseenter', this.onContentMouseEnter.bind(this));
    this.content.addEventListener('mouseleave', this.onContentMouseLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  removeHoverEvents() {
    this.summary.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.summary.removeEventListener('mouseleave', this.onSummaryMouseLeave.bind(this));
    this.content.removeEventListener('mouseenter', this.onContentMouseEnter.bind(this));
    this.content.removeEventListener('mouseleave', this.onContentMouseLeave.bind(this));
    this.summary.removeEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
      this.onToggle();
    }
  }

  onSummaryMouseLeave(event) {
    // Check if we're entering the mega menu content
    if (!this.content.contains(event.relatedTarget) && !this.summary.contains(event.relatedTarget)) {
      this.scheduleClose();
    }
  }

  onContentMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  onContentMouseLeave(event) {
    if (!this.contains(event.relatedTarget)) {
      this.scheduleClose();
    }
  }

  scheduleClose() {
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  onSummaryClick(event) {
    const parentLink = this.summary.querySelector('.mega-menu__parent-link');
    if (parentLink) {
      event.preventDefault();
      window.location.href = parentLink.href;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
